import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, MessageSquare } from "lucide-react";
import { api, fmtDate, ghs } from "../../lib/api";
import { PageHeader } from "../../components/site/Bits";
import { Stat } from "./kit";

export default function Overview() {
  const [s, setS] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [resets, setResets] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {});
    api.get("/admin/messages").then((r) => setMsgs(r.data.slice(0, 5))).catch(() => {});
    api.get("/admin/reset-requests").then((r) => setResets(r.data)).catch(() => {});
  }, []);
  const t = s?.transactions || {};
  return (
    <div className="space-y-10">
      <PageHeader eyebrow="Admin" title="Overview" text="Store performance and items needing attention.">
        {s && <span className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${s.payment_mode === "live" ? "border-emerald-500/30 text-emerald-300" : "border-amber-500/30 text-amber-300"}`} data-testid="admin-payment-mode">Payments: {s.payment_mode.toUpperCase()}</span>}
      </PageHeader>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Revenue" value={ghs(s?.revenue_minor || 0)} accent="text-amber-400" testId="stat-revenue" />
        <Stat label="Customers" value={s?.users ?? "–"} testId="stat-users" />
        <Stat label="Products" value={s?.products ?? "–"} testId="stat-products" />
        <Stat label="Purchases" value={s?.purchases ?? "–"} testId="stat-purchases" />
        <Stat label="Successful" value={t.success ?? "–"} accent="text-emerald-400" testId="stat-success" />
        <Stat label="Pending" value={t.pending ?? "–"} accent="text-amber-300" testId="stat-pending" />
        <Stat label="Failed" value={t.failed ?? "–"} accent="text-red-400" testId="stat-failed" />
        <Stat label="Cancelled" value={t.cancelled ?? "–"} testId="stat-cancelled" />
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card-rx p-6" data-testid="admin-reset-requests">
          <h2 className="flex items-center gap-2 font-semibold text-white"><KeyRound size={17} className="text-amber-400" /> Password reset requests</h2>
          {resets.length === 0 ? <p className="mt-4 text-sm text-slate-500">No open requests.</p> : (
            <ul className="mt-4 divide-y divide-white/[0.05]">
              {resets.map((r) => (
                <li key={r.id} className="flex items-center justify-between py-3 text-sm">
                  <span className="font-mono-rx text-slate-300">{r.phone}</span>
                  <Link to={`/admin/users/${r.user_id}`} className="text-emerald-300">Open user</Link>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="card-rx p-6" data-testid="admin-messages">
          <h2 className="flex items-center gap-2 font-semibold text-white"><MessageSquare size={17} className="text-emerald-400" /> Latest contact messages</h2>
          {msgs.length === 0 ? <p className="mt-4 text-sm text-slate-500">No messages yet.</p> : (
            <ul className="mt-4 space-y-4">
              {msgs.map((m) => (
                <li key={m.id} className="text-sm">
                  <p className="text-white">{m.name} <span className="text-slate-500">· {m.contact} · {fmtDate(m.created_at)}</span></p>
                  <p className="mt-1 line-clamp-2 text-slate-400">{m.message}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
